"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dictionary = exports.MapUtils = void 0;
var MapUtils;
(function (MapUtils) {
    function getOrThrow(map, key) {
        const el = map.get(key);
        if (el === undefined)
            throw new Error(`Expected to find an element for specified key, but got instead: undefined.`);
        return el;
    }
    MapUtils.getOrThrow = getOrThrow;
})(MapUtils = exports.MapUtils || (exports.MapUtils = {}));
/**
 * Like a map, but better typed.
 * Keys can only be string or number.
 */
class Dictionary extends Map {
    has(key) {
        return super.has(key);
    }
    get(key) {
        return super.get(key);
    }
}
exports.Dictionary = Dictionary;
//# sourceMappingURL=map.js.map